import { useEffect } from 'react';
import HomeProducts from '../components/HomeProducts';
import { NonOrderableProducts } from '../components/NonOrderableProducts';
import ProductCards from '../components/ProductCards';
import { ListMedicationsProps } from '../interface/interface';

export const ListMedications = ({
  products,
  addProductToCart,
  removeProductFromCart,
  nonOrderable,
  isHome,
  wishListProducts,
}: ListMedicationsProps) => {
  useEffect(() => {
    localStorage.removeItem('selectedCategories');
  }, []);

  const showHomeProducts = isHome && !!products?.length;
  const showListProducts =
    !isHome && !!(products?.length || nonOrderable?.length);

  return (
    <div>
      {showHomeProducts ? (
        <ul
          className={
            'grid grid-cols-5 gap-4 xs:grid-cols-1 sm:grid-cols-2 sm-land:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'
          }
        >
          <HomeProducts
            products={products}
            totalProducts={products.length}
            addProductToCart={addProductToCart}
            removeProductFromCart={removeProductFromCart}
            wishListProducts={wishListProducts ?? []}
          />
          {nonOrderable?.length ? (
            <NonOrderableProducts
              data={nonOrderable}
              enableShopAllMedications={false}
            />
          ) : null}
        </ul>
      ) : null}

      {showListProducts ? (
        <ul
          className={
            'grid grid-cols-5 gap-4 xs:grid-cols-1 sm:grid-cols-2 sm-land:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'
          }
        >
          {products?.length
            ? products.map((product) => (
                <div key={product.id}>
                  <ProductCards
                    product={product}
                    addProductToCart={addProductToCart}
                    removeProductFromCart={removeProductFromCart}
                    isAccessories={false}
                    allowedProduct={product?.allowedProducts?.length}
                    isGuest={false}
                    wishListProducts={wishListProducts}
                  />
                </div>
              ))
            : null}

          {nonOrderable?.length ? (
            <NonOrderableProducts
              data={nonOrderable}
              enableShopAllMedications={false}
            />
          ) : null}
        </ul>
      ) : null}

      {!showHomeProducts && !showListProducts ? (
        <div>No Products found to display</div>
      ) : null}
    </div>
  );
};
